import {
  GETList,
  GETDetail,
  POSTWithToken,
  DELETEWithToken,
  PUTWithToken,
} from "@/services/base-service";

const API_URL = "/api/resignation/v1";

export const getResignationList = (values) => {
  const url = `${API_URL}/list`;
  return GETList(url, values);
};

export function createResignation(values) {
  const url = `${API_URL}/create`;
  return POSTWithToken(url, values);
}

export function getResignationDetail(id) {
  return GETDetail(API_URL, id);
}

export function archiveResignation(id) {
  const url = `${API_URL}/${id}/soft`;
  return DELETEWithToken(url);
}

export function unarchiveResignation(id) {
  const url = `${API_URL}/${id}/unarchive`;
  return PUTWithToken(url);
}

export function deleteResignation(id) {
  const url = `${API_URL}/${id}`;
  return DELETEWithToken(url);
}

export function submitResignation(id) {
  const url = `${API_URL}/${id}/submit`;
  return PUTWithToken(url, null);
}

export function approveResignation(id) {
  const url = `${API_URL}/${id}/approve`;
  return PUTWithToken(url, null);
}

export function approveResignationLm(id) {
  const url = `${API_URL}/${id}/approve-lm`;
  return PUTWithToken(url, null);
}

export function rejectResignation(id) {
  const url = `${API_URL}/${id}/reject`;
  return PUTWithToken(url, null);
}

export function processResignation(id, body) {
  const url = `${API_URL}/${id}/process`;
  return PUTWithToken(url, body);
}
